/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FunctionComponent, useEffect, useRef, useState } from 'react'

import { sitePath } from '../../../assets/ts/api/api'
import { mpfRListsHttp } from '../../../assets/ts/api/mpf-r-lists-http'
import { encodeHTML, formatBody, sendEmail, sendNotification } from '../../../assets/ts/general/general'
import ActionButtons from '../../../components/buttons/action-buttons'
import Buttons from '../../../components/buttons/buttons'
import { DiscussionCols } from '../../../utils/constants/global-list-columns'
import InputSelect from '../../../utils/controls/input-select'
import InputTextArea from '../../../utils/controls/input-text-area'

interface replyProps {
  ItemGUID: string
  allFiles: any
  currentInquiry: any
  discussion: any
  id: string
  isInquiry: boolean
  refreshData: FunctionComponent
  role: any
}
const initialValues = ['reply']
let elementHeightValue: number
let offsetLeftValue: number
let offsetTopValue: number
let offsetWidthValue: number
let popupTop: number
let xPositionValue: any

const Reply = (props: replyProps) => {
  /** *** Responsive Popup Code Start*****/
  const reply = useRef<any>(null)
  const popupBtnRef = useRef<any>(null)
  const [fieldsData, setFieldsData] = useState({ DiscComment: '' })
  const [validation, setValidation] = useState({ DiscComment: false })
  const [disable, setDisable] = useState(false)
  const [popupHeight, setPopupHeight] = useState<number>()
  const [xPositionValueUpdate, setXPositionValueUpdate] = useState<number>()
  const [selectedFiles, setSelectedFiles] = useState('')
  const [allFiles, setAllFiles] = useState<any>([])
  const [actionBtnShowHide, setActionBtnShowHide] = useState({
    reply: false,
  })
  const [showActionPopups, setShowActionPopups] = useState({
    reply: false,
  })
  const showHide: any = { ...actionBtnShowHide }

  function popupCloseOpenFunctionality(
    type: any,
    value: number,
    top: number,
    xPosition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number
  ) {
    popupTop = top
    xPositionValue = xPosition
    offsetLeftValue = left
    offsetTopValue = top
    offsetWidthValue = offsetWidth
    initialValues.forEach((element) => {
      showHide[element] = false
    })
    setActionBtnShowHide(showHide)
    if (type) {
      setActionBtnShowHide({ ...showHide, [type]: value })
      setShowActionPopups({ ...showHide, [type]: value })
    }
  }
  useEffect(() => {
    const filesArray = []
    if (props?.allFiles?.length > 0) {
      props?.allFiles?.forEach((element) => {
        filesArray.push(element?.fileName)
      })
      setAllFiles(filesArray)
    } else {
      setAllFiles([])
    }
  }, [props?.allFiles])
  useEffect(() => {
    setPopupHeight(window.innerHeight - (offsetTopValue + 65))
    const popupWidthData = popupBtnRef.current
      ? popupBtnRef.current.offsetWidth
      : 0
    // setpopupwidth(popupWidthData)
    if (popupWidthData < xPositionValue) {
      xPositionValue = xPositionValue - popupWidthData
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData < window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = offsetLeftValue
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData > window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = 0
      setXPositionValueUpdate(xPositionValue)
    }
  }, [showActionPopups])
  async function replyDiscussions() {
    const userdetails = await mpfRListsHttp().me()
    const userId = userdetails.userId
    setDisable(true)
    const validationset = { DiscComment: false, DiscSubj: false }
    const comment = encodeHTML(fieldsData?.DiscComment?.trim())
    if (!comment) {
      validationset.DiscComment = true
    }
    if (!validationset.DiscSubj && !validationset.DiscComment) {
      const ObjectArray = {}
      ObjectArray[DiscussionCols.Comment] = comment
      ObjectArray[DiscussionCols.InquiryID] = props?.ItemGUID
      ObjectArray[DiscussionCols.IsActionComment] = false
      ObjectArray[DiscussionCols.ItemCreated] = new Date()
      ObjectArray[DiscussionCols.ItemCreatedBy] = userId
      ObjectArray[DiscussionCols.InquiryGUID] = props?.ItemGUID
      ObjectArray[DiscussionCols.ItemModified] = new Date()
      ObjectArray[DiscussionCols.ItemModifiedBy] = userId
      ObjectArray[DiscussionCols.CommentDocumentName] = selectedFiles
      ObjectArray[DiscussionCols.ParentCommentCode] = props?.id?.toString()
      ObjectArray[DiscussionCols.UserRole] = props.role

      const DiscussionList = await mpfRListsHttp().getList('InquiryDiscussionsList')
      await DiscussionList.addOrUpdateItem(ObjectArray)
        .then(async (data: any) => {
          props?.refreshData()
          setDisable(false)
          setActionBtnShowHide({ ...actionBtnShowHide, reply: false })

          if (props?.discussion?.CommentType === "Customer") {
            await handleEmails(
              comment,
              userdetails
            )
            await sendNotification(
              'CUSTOMER_DISCUSSION_RESPOND', 
              {
                ...props?.currentInquiry,
                parentUser: props?.discussion.ItemCreatedBy.userID
              }, 
              userdetails, 
              props?.role?.replace('[SECTION_NAME]', '').trim() || '', 
              !props?.isInquiry)
          } else {
            await sendNotification(
              'INTERNAL_DISCUSSION_RESPOND', 
              {
                ...props?.currentInquiry,
                parentUser: props?.discussion.ItemCreatedBy.userID
              }, 
              userdetails, 
              props?.role?.replace('[SECTION_NAME]', '').trim() || '', 
              !props?.isInquiry)
          }
        })
    } else {
      setDisable(false)
      setValidation({ ...validation, DiscComment: validationset.DiscComment })
    }
  }
  function DiscussionComment(e: any) {
    setFieldsData({ ...fieldsData, DiscComment: e.target.value })
  }

  const handleEmails = async (comment, userdetails) => {
    const userId = userdetails.userId
    const detailView = props?.isInquiry ? 'detailview' : 'dueoutdetailview'
    const dataGUID = props?.isInquiry ? 
    props?.currentInquiry?.InquiryGUID : props?.currentInquiry?.DueOutGUID
    const dataID = props?.isInquiry ? 
    props?.currentInquiry?.InquiryID : props?.currentInquiry?.DueOutID
    const navURL = sitePath + `/${detailView}/${dataGUID}`
    let bodyText = ''
    if (selectedFiles !== '') {
      bodyText = `New comment has been added for ${selectedFiles}.`
    }

    const emailBodyData = {
      ...props?.currentInquiry,
      Title: props?.discussion?.Subject,
      bodyText: bodyText,
      comment: comment,
    }

    const body = formatBody('Reply', emailBodyData, navURL)
    const to = props?.currentInquiry?.Customer?.userID

    const emailObjData = {
      ...props?.currentInquiry,
      Action: props?.discussion?.CommentType === "Internal" ? "Reply Internal Discussion" : "Reply Customer Discussion",
      ItemGUID: dataGUID,
      ItemID: dataID,
      Title: props?.currentInquiry?.Subject,
    }

    const emails:  Promise<any>[] = []

    if (to && to !== userId) {
      emails.push(sendEmail({
        bcc: '',
        bodySurvey: '',
        cc: '',
        data: emailObjData,
        discussion: body,
        isDiscussion: true,
        isSurvey: false,
        loginuserId: userId,
        navURL: navURL,
        subject: `${props?.isInquiry ? 'Inquiry' : 'Due Out'} '${dataID}' – New reply has been added`,
        to: to
      }))
    }

    if (emails.length > 0 && props?.currentInquiry?.TeamMembers?.length > 0) {
      const teamMembers = props?.currentInquiry?.TeamMembers
      for (const teamMember of teamMembers) {
        if (teamMember.userID !== userId) {
          emails.push(sendEmail({
            bcc: '',
            bodySurvey: '',
            cc: '',
            data: emailObjData,
            discussion: body,
            isDiscussion: true,
            isSurvey: false,
            loginuserId: userId,
            navURL: navURL,
            subject: `${props?.isInquiry ? 'Inquiry' : 'Due Out'} '${dataID}' – New reply has been added`,
            to: teamMember.userID
          }))
        }
      }
    }

    await Promise.all(emails)
  }
  useEffect(() =>{
    if(actionBtnShowHide?.reply){
      const element = document.getElementsByClassName('reply-div')
    if(element){
      setTimeout(() =>{
        element?.[0]?.scrollIntoView({ behavior: 'smooth', block: 'start'})
      }, 100)
    }
    }
  }, [actionBtnShowHide?.reply])
  return (
    <>
      <ActionButtons
        className={
          actionBtnShowHide?.reply
            ? 'btn btn-xs font-12 color-primary popup-arrow p-relative ms-auto'
            : 'btn btn-xs font-12 color-primary p-relative ms-auto'
        }
        isClick='reply'
        label='Reply'
        name='Reply'
        popupCloseOpenFunctionality={popupCloseOpenFunctionality}
        ref={reply}
        showHide={actionBtnShowHide.reply}
        type='button'
      />
      {actionBtnShowHide?.reply ? (
        <div
          className='popup popup-sm'
          ref={popupBtnRef}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            top: popupTop + 8,
          }}
        >
          {/* <div className='font-12 bgcolor-primary-light border-primary p-1'>
            <span className='icon-info'></span> UNCLASSIFIED/FOUO USE ONLY
          </div> */}
          <div className='pt-2'>
            <InputSelect
              className='form-sm font-13 sourcesanspro'
              defaultSelect={true}
              formClassName='form-vertical'
              inputProps={{
                className: 'font-12 poppins-medium title-color2 mb-1',
                id: 'comment',
                name: 'Comment',
                placeholder: 'Select',
              }}
              label='Comment For (Optional)'
              onChange={(e: any) => setSelectedFiles(e.target.value)}
              options={allFiles}
              value={selectedFiles}
            />
          </div>
          <div className='pt-2'>
            <InputTextArea
              className='form-lg font-13 sourcesanspro  min-h-100 p-1'
              cols='30'
              error={validation.DiscComment}
              formClassName=' form-vertical'
              info='Comment'
              infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'font-12 poppins-medium title-color2 mb-1',
                id: 'Comment',
                name: 'Comment',
                placeholder: 'Enter your Comment',
              }}
              isInfo
              isMandatory
              label='Comment'
              onChange={DiscussionComment}
              rows='3'
              type='textarea'
            />
          </div>

          <div className='pt-2 d-flex gap-2 reply-div'>
            <Buttons
              aria-label='Ok'
              className='btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold'
              icon='icon-checked font-12 me-1'
              label='Ok'
              onClick={replyDiscussions}
            />
            <ActionButtons
              className='btn-border1 title-color3 btn-sm font-11 border-radius text-uppercase poppins-semibold'
              icon='icon-close font-9 me-1 color-primary'
              isClick='reply'
              label='Cancel'
              name='Cancel'
              popupCloseOpenFunctionality={popupCloseOpenFunctionality}
              ref={reply}
              showHide={showActionPopups.reply}
              type='button'
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}
export default Reply